import { FormSectionElements, FormSections, LOVValues } from "../entities/formTemplateDataType";
import { AbstractResponseHandler } from "./AbstractResponseHandler";
import DataUtils from "../utilities/DataUtils";
import { getRootComponent } from "../utilities/ElementUtils";

/**
 * To handle service-call responses in ehocm-partner-id application.
 */
export class EhocmPartnerIdResponseHandler implements AbstractResponseHandler {
  constructor() {}

  handle(response: any, fieldOrSection: FormSectionElements | FormSections): any {
    const name = fieldOrSection instanceof FormSectionElements ? fieldOrSection.LoadBindName : fieldOrSection.ENUTitle;
    console.log('about to execute handle for ' + name + ' in EhocmPartnerIdResponseHandler...');
    
    switch (name) {
      case 'Review your application details':
        return this.handleApplicationSubmission(response, fieldOrSection);
      default:
        return this.handleSearchResponse(response, fieldOrSection);
    }
  }

  private handleSearchResponse(response: any, fieldOrSection: FormSectionElements | FormSections): any {
    if (response && typeof response === 'object') {
      const root = getRootComponent(fieldOrSection);
      root.Entity = response;
      DataUtils.assignFormValue(root);
    }
    return { processSuccessful: true };
  }

  private handleApplicationSubmission(response: any, fieldOrSection: FormSectionElements | FormSections): any {
    if (response.status === 'Created') {
      const submittedApplicationIdField = fieldOrSection.findFieldByName('submittedApplicationId');
      if (submittedApplicationIdField) {
        submittedApplicationIdField.Value = response.id;
      }
      return { processSuccessful: true, stepIndex: 'The application was sent'};
    }
    return { processSuccessful: false, stepIndex: 'Technical error'};
  }
}